import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import { Settings } from './Settings';

export interface Result {
	roMaxPriceSettings: Settings;
}

export const find = async (client: ApiClient, userId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/ro-max-price-settings');
	const response = await client.fetch(url.expand({ userId }));
	return response.json();
};
